module.exports = function transformAlertData(entity) {
	const { attributes } = entity;
	let data = {
		id: entity.id,
		type: entity.type,
		severity: attributes ? attributes.field_severity : "info",
		text: attributes && attributes.body ? attributes.body.value : "",
	};
	return data;
};
